import Login from './components/auth/Login'
import TermReport from './components/TermReport'

const routes = [
  { 
      path: '/',
      name: 'login', 
      component: Login,
      meta: {
        requiresVisitor: true,
      }
  },  
 
  {
    path: '/term-report',
    name: 'termReport',
    component: TermReport,
    meta: {
      requiresAuth: true
    }
  },
  
]

export default routes